import { DatasourcedWidgetMetadata } from '@/modules/ta/widget/models/metadata/DataSourcedWidgetMetadata';
import { MediaWidgetDrawOption } from '@/modules/ta/widget/models/drawoptions/MediaWidgetDrawOption';

export class MediaWidgetMetadata extends DatasourcedWidgetMetadata {
  /**
   * Widget content.
   *
   * @var {string}
   */
  content;

  /**
   * Allows us to use what's already in the DB as the content to be saved.
   *
   * @var {boolean}
   */
  keep_content;

  /**
   * @var {SelectedEntity}
   */
  entity;

  /**
   * @var {boolean}
   */
  is_header;

  /**
   * @var {BaseDrawOption}
   */
  draw_options;

  constructor(model = {}) {
    super(model);

    this.content = model.content;
    this.keep_content = model.keep_content;
    this.entity = model.entity;
    this.is_header = model.is_header;
    this.draw_options = new MediaWidgetDrawOption(model.draw_options);
  }
}
